import { render, staticRenderFns } from "./mySaveList.vue?vue&type=template&id=236df1f7&"
import script from "./mySaveList.vue?vue&type=script&lang=js&"
export * from "./mySaveList.vue?vue&type=script&lang=js&"
import style0 from "./mySaveList.vue?vue&type=style&index=0&id=236df1f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports